export default __webpack_public_path__ + "e704bb0e8f399ea9a7e1499c93a8369b.png";